import defaultTheme from "./defaultTheme.es.js";
import THEME_ID from "./identifier.es.js";
import useThemeProps$1 from "../../system/esm/useThemeProps/useThemeProps.es.js";
function useThemeProps({
  props,
  name
}) {
  return useThemeProps$1({
    props,
    name,
    defaultTheme,
    themeId: THEME_ID
  });
}
export {
  useThemeProps as default
};
//# sourceMappingURL=useThemeProps.es.js.map
